import { notInExoSkeletonError } from './internal';
import {
  createPostMessageEventHandler,
  ExoSkeletonRuntimeDataEvent,
  isInExoSkeleton,
  sendRuntimeDataEvent,
} from './runtime';

export const NAVIGATION_HOST_MESSAGE_EVENT_NAME =
  'exo-skeleton-navigation-host-message';

export interface NavigationData {
  to: string;
}

type RuntimeNavigationEvent = ExoSkeletonRuntimeDataEvent<
  typeof NAVIGATION_HOST_MESSAGE_EVENT_NAME,
  NavigationData
>;

export interface ICreateNavigationHostParameters {
  onNavigate(event: RuntimeNavigationEvent): void;
}

function isNavigationDataEvent(
  data: ExoSkeletonRuntimeDataEvent<string, unknown>,
): data is RuntimeNavigationEvent {
  return data.type === NAVIGATION_HOST_MESSAGE_EVENT_NAME;
}

/**
 * Used to create a host for the ExoSkeleton navigation.
 */
export function createNavigationListener({
  onNavigate,
}: ICreateNavigationHostParameters) {
  if (!isInExoSkeleton()) {
    throw notInExoSkeletonError({ source: 'createNavigationListener' });
  }
  return createPostMessageEventHandler(function ({ data }: MessageEvent) {
    if (isNavigationDataEvent(data)) {
      onNavigate(data);
    }
  });
}

export function navigate(to: string) {
  if (!isInExoSkeleton()) {
    throw notInExoSkeletonError({ source: 'navigate' });
  }
  return sendRuntimeDataEvent<
    typeof NAVIGATION_HOST_MESSAGE_EVENT_NAME,
    NavigationData
  >(NAVIGATION_HOST_MESSAGE_EVENT_NAME, { to });
}
